import React, { ReactElement } from 'react'

export function CalendarIcon(): ReactElement {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mx-4 inline-block "
    >
      <path
        d="M26.375 5.375H3.625C2.6585 5.375 1.875 6.1585 1.875 7.125V26.375C1.875 27.3415 2.6585 28.125 3.625 28.125H26.375C27.3415 28.125 28.125 27.3415 28.125 26.375V7.125C28.125 6.1585 27.3415 5.375 26.375 5.375Z"
        // fill="#F1F8E5"
        className="stroke-primary"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 12.375H28.125"
        className="stroke-primary"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.875 8V1.875"
        className="stroke-primary"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21.125 8V1.875Z" fill="#C4C4C4" />
      <path
        d="M21.125 8V1.875"
        className="stroke-primary"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5625 17.625C7.32087 17.625 7.125 17.4291 7.125 17.1875C7.125 16.9459 7.32087 16.75 7.5625 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M7.5625 17.625C7.80413 17.625 8 17.4291 8 17.1875C8 16.9459 7.80413 16.75 7.5625 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M7.5625 23.75C7.32087 23.75 7.125 23.5541 7.125 23.3125C7.125 23.0709 7.32087 22.875 7.5625 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M7.5625 23.75C7.80413 23.75 8 23.5541 8 23.3125C8 23.0709 7.80413 22.875 7.5625 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M15 17.625C14.7584 17.625 14.5625 17.4291 14.5625 17.1875C14.5625 16.9459 14.7584 16.75 15 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M15 17.625C15.2416 17.625 15.4375 17.4291 15.4375 17.1875C15.4375 16.9459 15.2416 16.75 15 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M15 23.75C14.7584 23.75 14.5625 23.5541 14.5625 23.3125C14.5625 23.0709 14.7584 22.875 15 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M15 23.75C15.2416 23.75 15.4375 23.5541 15.4375 23.3125C15.4375 23.0709 15.2416 22.875 15 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M22.4375 17.625C22.1959 17.625 22 17.4291 22 17.1875C22 16.9459 22.1959 16.75 22.4375 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M22.4375 17.625C22.6791 17.625 22.875 17.4291 22.875 17.1875C22.875 16.9459 22.6791 16.75 22.4375 16.75"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M22.4375 23.75C22.1959 23.75 22 23.5541 22 23.3125C22 23.0709 22.1959 22.875 22.4375 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
      <path
        d="M22.4375 23.75C22.6791 23.75 22.875 23.5541 22.875 23.3125C22.875 23.0709 22.6791 22.875 22.4375 22.875"
        className="stroke-primary"
        strokeWidth="2"
      />
    </svg>
  )
}
